<template>
  <div
    class="absolute bottom-[60px] left-0 right-0 max-h-[111px] space-y-2 overflow-y-auto"
  >
    <div
      v-for="file in files"
      :key="file.name"
      class="mx-2 flex items-center justify-between rounded-sm bg-gray-200 px-2 py-1 text-primary"
    >
      <span class="flex-1 truncate font-semibold">
        {{ file.name }}
      </span>
      <icon-base
        :icon="IconDelete"
        width="12"
        height="12"
        view-box="0 0 16 16"
        class="flex-none cursor-pointer text-label"
        @click="removeFile(file)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconBase from "@/components/ui/IconBase.vue";
import IconDelete from "@/components/icons/IconDelete.vue";

const emit = defineEmits<{
  "remove-file": [File];
}>();

defineProps<{
  files: File[];
}>();

const removeFile = (file: File) => {
  emit("remove-file", file);
};
</script>
